import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M30 90q20-30 70-20 50-10 70 20-20-12-40-10-15 4-30 0-15 4-30 0-20-2-40 10" }, null, -1),
    _createElementVNode("path", { d: "M92 78h16v20H92z" }, null, -1),
    _createElementVNode("path", {
      fill: "var(--mc-avatar)",
      d: "M92 98h16l-8 16z"
    }, null, -1),
    _createElementVNode("path", { d: "M30 100q20 38 70 32 50 6 70-32-70 12-140 0" }, null, -1)
  ]))]))
}
export default { render: render }